export type AddressPartsValue = {
  address: string;
  city: string;
  postal_code: string;
  country: string;
};

export type AddressPartField = keyof AddressPartsValue;

const REQUIRED_FIELDS: AddressPartField[] = [
  "address",
  "city",
  "postal_code",
  "country",
];

export function getMissingAddressFields(
  parts: AddressPartsValue,
): AddressPartField[] {
  return REQUIRED_FIELDS.filter((field) => !parts[field].trim());
}

export function isAddressComplete(parts: AddressPartsValue): boolean {
  return getMissingAddressFields(parts).length === 0;
}

/** Stable key for comparing whether structured address fields changed. */
export function addressPartsValidationKey(parts: AddressPartsValue): string {
  return [parts.address, parts.city, parts.postal_code, parts.country]
    .map((value) => value.trim())
    .join("\u0001");
}

export function partsFromSuggestion(suggestion: {
  label: string;
  address?: string | null;
  city?: string | null;
  postal_code?: string | null;
  country?: string | null;
}): AddressPartsValue {
  return {
    address: (suggestion.address ?? suggestion.label).trim(),
    city: (suggestion.city ?? "").trim(),
    postal_code: (suggestion.postal_code ?? "").trim(),
    country: (suggestion.country ?? "").trim(),
  };
}
